import { PricingEditorRoot } from 'common/drawers/PricingEditor/view/pricingEditor.root'
import { useCallback, useMemo } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { EditorMode as PriceEditorMode } from 'modules/common/drawers/PricingEditor/domain'
import { useNotifications } from '@sequencehq/core-components'
import { NEW_PRICE_PATTERN } from 'common/drawers/PricingEditor/domain/pricingEditor.constants'
import { usePermissions } from 'lib/rbac'

export const useConnector = () => {
  const params = useParams<{
    productId: string
    listPriceId: string
  }>()
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { displayNotification } = useNotifications()

  const initialPriceEditorMode = useMemo(() => {
    if (!params.listPriceId || params.listPriceId.match(NEW_PRICE_PATTERN)) {
      return PriceEditorMode.CREATE
    }

    return PriceEditorMode.EDIT
  }, [params.listPriceId])

  const onSave = useCallback(() => {
    navigate(`/products/${params.productId}`)
    displayNotification('List price created', {
      type: 'success'
    })
  }, [displayNotification, navigate, params.productId])

  const onCancel = useCallback(() => {
    navigate(`/products/${params.productId}`)
  }, [navigate, params.productId])

  const duplicateFrom = searchParams.get('duplicateFrom') || undefined

  return {
    initialPriceEditorMode,
    onSave,
    onCancel,
    duplicateFrom
  }
}

export const ListPriceEditorRouteWrapper = () => {
  const context = useConnector()

  const { can } = usePermissions()

  if (!can('org.product:update')) {
    return (
      <PricingEditorRoot
        variant="list"
        initialMode={PriceEditorMode.REVIEW}
        onCancel={context.onCancel}
      />
    )
  }

  return (
    <PricingEditorRoot
      variant="list"
      initialMode={context.initialPriceEditorMode}
      onSave={context.onSave}
      onCancel={context.onCancel}
      duplicateFrom={context.duplicateFrom}
    />
  )
}
